import ConfirmSuccess from './ConfirmSuccess';
export default ConfirmSuccess;
